import React, { useState, useEffect, useRef, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaTrashAlt, FaPrint, FaUsers, FaSearch } from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import { format, addDays, isValid } from 'date-fns';

import Swal from 'sweetalert2';

// import 'react-datepicker/dist/react-datepicker.css';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

import { toast } from 'react-toastify';
// import PrintData9af from '../../PrintData9af';
import Editns2 from './EditEni';

import DisplayInfoEni from '../../DisplayInfoEni';
import AfficheImpression from './AfficheImpression';
import Bunexe_service from '../../../Bunexe_service';
import DisplayInfoEnic from '../../DisplayInfoEnic';

const Nouveauenic = ({ ecole_selection, titre_ }) => {
  // const componentRef = useRef();
  const nomref = useRef();
  /** les variables */
  const [an_eni, setAnEni] = useState('');
  const [mat_eni, setMatEni] = useState('');
  const [moyns2, setMoyns2] = useState(0.0);
  const [infoPh, setInfoPh] = useState([]);
  const [alreadyLoaded, setAlreadyLoaded] = useState(false);
  const [rech_, setRech_] = useState('');
  const [mydoc, setMydoc] = useState('');
  const [section, setSection] = useState('Prescolaire');
  let tt = '';
  let bloburl = '';

  const [liste_eleve, set_Liste_eleve] = useState([]);
  let url_ = Bunexe_service.url;
  //'http://localhost:8086';

  const { Ecole } = ecole_selection;

  const getinfoPh = async () => {
    setAlreadyLoaded(false);
    try {
      fetch(url_ + `/recherche/enic/${an_eni}/${mat_eni}`)
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          setInfoPh(data);
          setAlreadyLoaded(true);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const supprimer = async (infoEleve) => {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    };
    try {
      fetch(url_ + `/enic/delete_eleve/${infoEleve.id}`, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            //  listeEleves_func(Ecole);

            reload_List();
            Swal.fire(
              'Supprime!',
              'Vous avez supprimé cet enregistrement avec succes.',
              'success'
            );
            //setShow(false);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error('Erreur de suppression ...', error);
    }
  };
  const listeEleves_func = async (Ecole) => {
    try {
      fetch(url_ + `/enic/${Ecole}`)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          //setListe_ecole(data);
          set_Liste_eleve(data);
          // printTable();
          // console.log(` Test ===>${mydoc}`);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const reload_List = () => {
    listeEleves_func(Ecole);
  };

  const submitform = (e) => {
    e.preventDefault();

    if (moyns2 < 1 || moyns2 > 9.99) {
      Swal.fire(
        'Erreur!',
        'La moyenne doit etre comprise entre 1 et 9.99',
        'error'
      );
    } else {
      let Form_data = {
        an_eni,
        mat_eni,
        AN_encours: '2021',
        IDENTIFIANT: infoPh[0].IDENTIFIANT.trim(),
        NOMEL: infoPh[0].NOMEL.trim(),
        PRENOMEL: infoPh[0].PRENOMEL.trim(),
        SEXE: infoPh[0].SEXE == '1' ? 'M' : 'F',
        DNAISS: infoPh[0].DNAISS,
        mat_eni: infoPh[0].MATRICULE.trim(),
        Zone: ecole_selection.Zone.trim(),
        SESSION: 'O',
        Code_Ecole: ecole_selection.Ecole.trim(),
        District: ecole_selection.District.trim(),
        Moy: moyns2,
      };
      // alert(JSON.stringify(Form_data));
      /*
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Form_data),
      };
      try {
        fetch(url_ + '/eni/add_eleve', requestOptions)
          .then((response) => {
            return response.json();
            //else throw Error(response.statusText);
          })
          .then((data) => {
            if (data.hasError) {
              toast.error(data.message, {
                position: toast.POSITION.TOP_RIGHT,
              });
              //afficherMessage(data.message);
            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Enregistrement Sauvegardé.',
                showConfirmButton: false,
                timer: 1500,
              });
              listeEleves_func(Ecole);
              // resetForm();
              // nomref.focus();
            }
            // console.log(data);
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (error) {
        console.error("Erreur d'insertion ...", error);
      }
      */
      //alert(JSON.stringify(Form_data));
    }
  };
  const myheader = {
    LibelleEt: ecole_selection.LibelleEt,
    AdresseEt: ecole_selection.AdresseEt,
    Ecole: ecole_selection.Ecole,
  };
  const printTable = () => {
    var doc = new jsPDF({ orientation: 'landscape', format: 'legal' });
    var totalPagesExp = '{total_pages_count_string}';
    var pageHeight1 =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    let xOffset =
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
    let Tt =
      Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
      doc.internal.getFontSize();
    let str = '';
    let pageHeight = 11;
    let message_ = `${pageHeight1} === ${Tt} === ${titre_.length}`;
    // alert(message_);
    doc.autoTable({
      html: '#mytable',

      didDrawPage: function (data) {
        // Header
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.setFontStyle('normal');

        //doc.text(titre_, data.settings.margin.left + 15, 22);
        //doc.text(titre_, pageWidth1 / 2 - Tt / 2, 22);
        doc.text(
          titre_.trim().toUpperCase(),
          pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 4.2) / 2,
          22
        );
        doc.text(
          ecole_selection.LibelleEt.trim(),
          pageWidth1 / 2 - (ecole_selection.LibelleEt.trim().length * 3.65) / 2,
          30
        );

        doc.text(
          ecole_selection.Ecole.trim(),
          pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
          38
        );

        // Footer
        str = 'Page ' + doc.internal.getNumberOfPages();
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str =
            str +
            ' sur ' +
            totalPagesExp +
            '     ===> Imprimé le ' +
            new Date().toISOString();
        }
        doc.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize;
        pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
      margin: { top: 44 },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    tt = doc.output('blob');

    let blobPDF = new Blob([tt], { type: 'application/pdf' });
    bloburl = URL.createObjectURL(blobPDF);
    tt = bloburl;
    //setMydoc(tt);
    //     let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    // width=0,height=0,left=-1000,top=-1000`;
    let params = `scrollbars=0,resizable=0,status=0,location=0,toolbar=0,menubar=0,
width=1200,height=600,left=200,top=120,status=0`;

    window.open(tt, 'Impression', params);
    //console.log(tt);
  };
  // setDefaultLocale('fr');
  // useEffect(() => {
  //   // listeEleves_func(Ecole);
  //   // nomref.current.focus();
  // }, [liste_eleve.length]);
  const onDisplayInfoEniClick = (candidatChoisi) => {
    let Form_data = {
      identifiant: candidatChoisi.IDENTIFIANT,
      code_section: candidatChoisi.IDSECTION,
      an_encours: '1920',
      an_eni_ancien: candidatChoisi.ANNEE,
      mat_eni_ancien: candidatChoisi.MATRICULE,
      code_dept: ecole_selection.Code_direction,
      ecole: ecole_selection.Ecole,
      Code_siege: ecole_selection.CodeSiege,
      session_encours: 'O',
      session_ancien: 'O',
      section:
        candidatChoisi.IDSECTION.substr(1, 1) === 'P'
          ? 'Prescolaire'
          : 'Fondamentale',
    };

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Form_data),
    };
    try {
      fetch(url_ + '/enic/add_eleve', requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Enregistrement Sauvegardé.',
              showConfirmButton: false,
              timer: 1500,
            });
            listeEleves_func(Ecole);
            // resetForm();
            // nomref.focus();
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }

    // console.log(JSON.stringify(Form_data));
    // alert(JSON.stringify(Form_data));
  };
  useEffect(() => {
    reload_List();
  }, []);
  return (
    <div className='container-fluid justify-content-center'>
      <div className='row mx-1'>
        <div className='col-xs-11 col-sm-11 col-md-4 col-lg-4 col-xl-4 border rounded py-3'>
          <h3 className='text-center'>{ecole_selection.LibelleEt}</h3>
          <h5 className='text-center'>{ecole_selection.AdresseEt}</h5>
          <h6 className='text-center'>{ecole_selection.Ecole}</h6>
          <hr />

          <Form autoComplete='off' noValidate>
            {/*            
            <Form.Row>
              <Form.Group as={Col} controlId='formGridSection'>
                <Form.Label>Section</Form.Label>
                <Form.Control
                  as='select'
                  value={section}
                  onChange={(e) => {
                    setSection(e.target.value);
                  }}
                >
                  <option>Prescolaire</option>
                  <option>Fondamentale</option>
                </Form.Control>
              </Form.Group>
            </Form.Row> */}

            <Form.Row>
              <Form.Group as={Col} controlId='formGridNom'>
                <Form.Label>Année Eni</Form.Label>
                <Form.Control
                  as='select'
                  value={an_eni}
                  onFocus={(e) => {
                    setInfoPh([]);
                  }}
                  onChange={(e) => setAnEni(e.target.value)}
                >
                  {Bunexe_service.Annee_academique.map((s) => (
                    <option value={s.an}>{s.libelle}</option>
                  ))}
                </Form.Control>

                {/* <MaskedInput
                  mask={[/\d/, /\d/, /\d/, /\d/]}
                  className='form-control'
                  placeholder='An Philo'
                  value={an_eni}
                  ref={nomref}
                  name='an_eni'
                  guide={false}
                  onChange={(e) => setAnPh(e.target.value)}
                /> */}
                {/* <Form.Control
                  type='text'
                  placeholder='An Philo'
                  value={an_eni}
                  ref={nomref}
                  name='an_eni'
                  // onFocus={(e) => listeEleves_func(Ecole)}
                  onChange={(e) => setAnPh(e.target.value)}
                /> */}
              </Form.Group>

              <Form.Group as={Col} controlId='formGridPrenom'>
                <Form.Label>Matricule ENI</Form.Label>
                <MaskedInput
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                  ]}
                  className='form-control'
                  placeholder='Matricule Philo'
                  value={mat_eni}
                  name='mat_eni'
                  onFocus={(e) => {
                    setInfoPh([]);
                  }}
                  onBlur={(e) => getinfoPh()}
                  onChange={(e) => setMatEni(e.target.value)}
                  guide={true}
                />
                {/* <Form.Control
                  type='text'
                  placeholder='Matricule Philo'
                  value={mat_eni}
                  name='mat_eni'
                  onBlur={(e) => getinfoPh()}
                  onChange={(e) => setMatEni(e.target.value)}
                /> */}
              </Form.Group>
            </Form.Row>
            <hr />
            {alreadyLoaded && infoPh.length == 0 && (
              <h3>
                Pas de Données. Cet candidat n'est pas un capiste ou a déjà
                reussi pour ce niveau
              </h3>
            )}
            {infoPh.length > 0 && (
              <DisplayInfoEnic
                d={infoPh}
                onDisplayInfoEniClick={onDisplayInfoEniClick}
              />
            )}
            <hr />
          </Form>
          <hr />
        </div>
        <div className='col-xs-11 col-sm-11 col-md-8 col-lg-8 col-xl-8'>
          {/* <ReactToPrint
            trigger={() => (
              <button className='btn btn-small btn-primary'>Imprimer</button>
            )}
            content={() => componentRef.current}
          /> */}
          {/* <h2 className='text-center'>Affichage des Donnees --{date_naiss}</h2> */}

          {liste_eleve && liste_eleve.length > 0 && (
            // <PrintData9af
            //   ref={componentRef}
            //   myheader={myheader}
            //   mydata_={liste_eleve}
            // />
            <Fragment>
              <div className='d-flex justify-content-between mt-2'>
                <div>
                  <div className='input-group'>
                    <button
                      className='btn btn-small btn-primary mr-2'
                      onClick={printTable}
                    >
                      <FaPrint size={20} />
                    </button>

                    {/* <AfficheImpression mydoc={tt} /> */}
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Recherche par nom...'
                      value={rech_}
                      onChange={(e) => setRech_(e.target.value)}
                      aria-label='Username'
                      aria-describedby='basic-addon1'
                    />
                    <div className='input-group-append'>
                      <span className='input-group-text' id='basic-addon1'>
                        <FaSearch />
                      </span>
                    </div>
                  </div>
                </div>
                <span>
                  <span
                    className='badge badge-dark px-3 font-weight-bolder'
                    style={{ fontSize: '20px' }}
                  >
                    {liste_eleve.length}
                  </span>
                  <FaUsers className='mx-1' size={20} />
                  {/* {' Enregistrements'} */}
                </span>
              </div>
              {/* <div style={{ height: '550px', overflowY: 'scroll' }}> */}
              <div
                style={{
                  height: '500px',
                  overflowY: 'scroll',
                  scrollbarWidth: 'thin',
                }}
              >
                <table className='table table-striped' id='mytable'>
                  <thead>
                    <tr>
                      {/* <th>Identifiant</th> */}
                      <th>Nom</th>
                      <th>Prenom</th>
                      <th>Sexe</th>
                      <th>Date Naissance</th>
                      <th>Section</th>

                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {liste_eleve
                      .filter((f) =>
                        rech_.length == 0
                          ? true
                          : f.NOMEL.toUpperCase().includes(
                            rech_.toUpperCase()
                          ) ||
                          f.PRENOMEL.toUpperCase().includes(
                            rech_.toUpperCase()
                          )
                      )
                      .map((el, index) => (
                        <tr key={index}>
                          {/* <td>{el.Identifiant}</td> */}
                          <td>{el.NOMEL}</td>
                          <td>{el.PRENOMEL}</td>
                          <td>{el.SEXE}</td>
                          <td>
                            {format(
                              addDays(new Date(el.DNAISS.substr(0, 10)), 1),
                              'dd/MM/yyyy'
                            )}
                            {/* {el.DNAISS} */}
                          </td>
                          <td>{el.section}</td>

                          <td>
                            <span className='px-1 mx-2'>
                              <Editns2
                                infoEleve={el}
                                myheader={myheader}
                                reload_List={reload_List}
                              />
                              |{' '}
                              <FaTrashAlt
                                onClick={(e) =>
                                  Swal.fire({
                                    title: `Voulez-vous vraiment supprimer ${el.Nom} ${el.Prenom} dont l'identifiant est :${el.Identifiant} ?`,
                                    icon: 'danger',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Oui, je le veux!',
                                  }).then((result) => {
                                    if (result.value) {
                                      supprimer(el);
                                    }
                                  })
                                }
                              />
                            </span>
                            |
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default Nouveauenic;
